import { Fragment, useEffect, useState } from "react";
import { isValidArray } from "../../Layout/Common/common";
import { useCurrentRefinements } from "react-instantsearch";
import { CustomHierarchicalMenu } from "./customHierarchicalMenu";

export const SelectedFilterMobileLite = () => {
  const { items, refine } = useCurrentRefinements;
  const [refinements, setRefinements] = useState(null);
  useEffect(() => {
    if (isValidArray(items)) {
      var refined = items.map((row) => {
        return {
          label: row.label.split(".").at(-1),
          refinements: row.refinements,
        };
      });
      setRefinements(refined);
    } else {
      setRefinements(null);
    }
  }, [items]);
  return (
    <Fragment>
      {isValidArray(refinements) && (
        <div className="row d-block d-lg-none">
          <div className="col-md-12">
            <div className="selectedFilter-wrapper selectedFilter-wrapperMob">
              <div className="selected-filters">
                {refinements.map((item) =>
                  item.refinements.map((subItem) => (
                    <div key={subItem.label} className="selectedFilters">
                      <p className="fs-13">{subItem.value}</p>
                      <i
                        className="fa-solid fa-xmark"
                        onClick={() => refine(subItem.value)}
                      />
                    </div>
                  ))
                )}
              </div>
              <button className="clear-filters-btn fs-14">Clear Filters</button>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
